import React, { Component } from "react";
import { toast } from "react-toastify";
import InvoicesTable from "./invoicesTable";
import InvoicePayModal from "./InvoicePayModal";
import Pagination from "../../components/common/pagination";
import { getInvoices } from "../../services/invoiceService";
import LoadingIndicator from "../../components/common/LoadingIndicator";

class Invoices extends Component {
  state = {
    invoices: [],
    currentPage: 1,
    pageSize: 10,
    sortColumn: { path: "duedate", order: "asc" },
    selectedTab: "outstanding",
    loading: true,
    totalCount: 0,
    payingInvoice: null,
  };

  async componentDidMount() {
    await this.populateInvoices();
  }

  populateInvoices = async () => {
    try {
      if (!this.state.loading) this.setState({ loading: true });
      const { currentPage, pageSize, sortColumn, selectedTab } = this.state;
      const response = await getInvoices({
        page: currentPage,
        pageSize,
        tab: selectedTab,
        sortBy: sortColumn.path,
        sortOrder: sortColumn.order.toUpperCase(),
      });
      const payload = response?.data;
      const invoices = payload?.data || [];
      const totalCount = payload?.pagination?.totalCount || 0;
      this.setState({ invoices, totalCount, loading: false });
    } catch (ex) {
      toast.error("Failed to load invoices");
      this.setState({ loading: false });
    }
  };

  handleTabChange = (tab) => {
    this.setState({ selectedTab: tab, currentPage: 1, loading: true }, this.populateInvoices);
  };

  handlePageChange = (page) => {
    this.setState({ currentPage: page, loading: true }, this.populateInvoices);
  };

  handleSort = (sortColumn) => {
    this.setState({ sortColumn, loading: true }, this.populateInvoices);
  };

  handlePay = (invoice) => {
    this.setState({ payingInvoice: invoice });
  };

  closePayModal = () => {
    this.setState({ payingInvoice: null });
  };

  handlePaid = () => {
    this.setState({ payingInvoice: null, loading: true }, this.populateInvoices);
  };

  render() {
    const { pageSize, currentPage, sortColumn, selectedTab, invoices, totalCount, loading, payingInvoice } = this.state;

    return (
      <React.Fragment>
        <div className="row">
          <div className="col">
            <h4 className="text-secondary">Invoices</h4>
            <ul className="nav nav-tabs invoice-tabs mb-3" role="tablist" aria-label="Invoice filters">
              <li className="nav-item">
                <button
                  type="button"
                  className={`nav-link ${selectedTab === "outstanding" ? "active" : ""}`}
                  onClick={() => this.handleTabChange("outstanding")}
                >
                  Outstanding
                </button>
              </li>
              <li className="nav-item">
                <button
                  type="button"
                  className={`nav-link ${selectedTab === "paid" ? "active" : ""}`}
                  onClick={() => this.handleTabChange("paid")}
                >
                  Paid
                </button>
              </li>
            </ul>
            {loading && <LoadingIndicator message="Loading invoices..." />}
            {!loading && (
              <p>
                You have {totalCount || "no"} {selectedTab === "paid" ? "paid" : "outstanding"} invoice
                {(totalCount > 1 || totalCount === 0) && "s"}.
              </p>
            )}
            <InvoicesTable
              invoices={invoices}
              sortColumn={sortColumn}
              onSort={this.handleSort}
              showPay={selectedTab === "outstanding"}
              onPay={this.handlePay}
            />
            <Pagination
              itemsCount={totalCount}
              pageSize={pageSize}
              currentPage={currentPage}
              onPageChange={this.handlePageChange}
            />
            {payingInvoice && (
              <InvoicePayModal
                invoice={payingInvoice}
                onClose={this.closePayModal}
                onPaid={this.handlePaid}
              />
            )}
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Invoices;
